import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { EditContent } from "@/features/consent-solutions";
import { checkUserPermissions } from "@/features/auth";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/cookie-management")({
  beforeLoad: async ({ context, params }) => {
    const { userDetails } = context as AuthorizedRouteContext;
    const { csId } = params;

    const isUserPermitted = checkUserPermissions(userDetails, ["COOKIE_DEFINITION_VIEW"], csId);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => (
    <EditContent fullWidth>
      <Outlet />
    </EditContent>
  ),
});

export { Route };
